import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Markup } from 'interweave';
import InfiniteScroll from "react-infinite-scroller";
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import axios from "axios";
import '../Dashboard.css';
import classes from "./ManageAlbum.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";
import Spinner from "../../Global/Spinner";
import EmptyContent from "../../Global/EmptyContent";

import noThumb from "../../../images/no-thumb.jpg";

function Videos() {
    const { id } = useParams();
    const [images, setImages] = useState(true);
    const [hasMore, sethasMore] = useState(true);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(false);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get('logged_user');

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`, {
                user_id: logged_user,
                album_id: id,
                action: 'GET_ALBUM_IMAGES'
            }, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(res => {
                setImages(res.data);
                res.data.length < 10 ? sethasMore(false) : sethasMore(true);
                setLoading(true);

                // console.log(res.data);
            }).catch(error => {
                console.log(error);
            });
    }, [logged_user])

    const loadMore = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`, {
                user_id: logged_user,
                album_id: id,
                page: page,
                action: 'GET_ALBUM_IMAGES'
            }, {
                headers: {
                    "Content-Type": "multipart/form-data"
                    }
            }).then(res => {
                if(res.data.message !== 'No images found') {
                    loading && hasMore && setImages([...images, ...res.data]);
                    res.data.length < 10 ? sethasMore(false) : sethasMore(true);
                    setpage(page + 1);
                }
            }).catch(error => {
                console.log(error);
            });
    }

    const handleDelete = (image_id) => {
        const image = document.getElementById(`image_${image_id}`);
        if(image) {
            if(window.confirm("Are you sure you want to remove this image?")) {
                const toast_id = toast.loading("Please wait...");
                axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`,
                    {
                        user_id: logged_user,
                        album_id: id,
                        image_id: image_id,
                        action: 'DELETE_IMAGE'
                    }, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    }
                ).then(res => {
                    // console.log(res.data);
                    image.remove();
                    toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});
                }).catch(err => {
                    console.log(err);
                })
            }
        }
    }

    const toggleCheckAll = () => {
        const checkboxes = document.querySelectorAll('#checkrow');
        const checkall = document.querySelector('#check-all');

        if(checkall.checked) {
            checkboxes.forEach((cb) => {
                cb.checked = true;
            });
        }else {
            checkboxes.forEach((cb) => {
                cb.checked = false;
            });
        }
    }

    const deleteAll = () => {
        if(window.confirm("Are you sure you want to delete all selected video?")) {
            const toast_id = toast.loading("Please wait...");
            let data = new FormData();
            data.append('user_id', logged_user);
            var array = [];

            var checkboxes = document.querySelectorAll('#checkrow');
            for (var i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked){
                    data.append('albumData[]', checkboxes[i].value)
                    array.push(checkboxes[i].value);
                }
            }

            axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`, data , {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }).then(res => {
                    // console.log(res.data);
                    if(res.data.status === 'success') {
                        array.forEach(item => {document.getElementById(`image_${item}`).remove();});
                        toast.update(toast_id, {render: "Images deleted successfully.", autoClose: 5000, type: "success", isLoading: false});
                    }else {
                        toast.update(toast_id, {render: "Something went wrong!", autoClose: 5000, type: "error", isLoading: false});
                    }
                }).catch(err => {
                    console.log(err);
                });
        }
    }
    
  return (
    <>
        <Helmet>
            <title>Manage Album</title>
        </Helmet>
        <div className="container_wrapper">
            <Header />
            <div className={`${styles.main} main`}>
                <ToastContainer />
                <Sidebar />
                <div className={styles.main_content}>
                    <div className={styles.content_body}>
                        {/* <div className={`${styles.title} mb-4 d-flex justify-content-between`}>
                            <h5><i className="fa-solid fa-film"></i> My Albums</h5>
                            <Link className="add_album_btn" to="/dashboard/add-album">
                                <button className="btn btn-secondary">Add Album</button>
                            </Link>
                        </div> */}
                        <div className={styles.card}>
                            <div className={`${styles.item_in_list} ${styles.list_header}`}>
                                <div className="checkbox">
                                    <input type="checkbox" name="checkRows" id="check-all" onClick={() => toggleCheckAll()} />
                                    <label></label> Select all
                                </div>
                                <div className={styles.delete_btn}>
                                    <button className="btn btn-danger" type="submit" onClick={() => deleteAll()}>
                                        <i className="fa-regular fa-trash-can"></i> Selected
                                    </button>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className={styles.content_items}>
                                    {
                                        images && images.map ?  <InfiniteScroll
                                            pageStart={0}
                                            loadMore={loadMore}
                                            hasMore={hasMore}
                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                            className='row'
                                        >
                                            {
                                                images.map((image, index) => {
                                                    return (
                                                        <div id={`image_${image.id}`} className={styles.item_in_list} key={index}>
                                                            <div className={styles.segment}>
                                                                <div className={styles.checkbox}>
                                                                    <input id="checkrow" type="checkbox" name="albumData[]" defaultValue={image.id} />
                                                                    <label></label>
                                                                </div>
                                                            </div>
                                                            <div className={styles.segment}>
                                                                <div className={styles.left}>
                                                                    <Link className="" target="_blank" rel="noreferrer" to={false} title="View">
                                                                        <img src={image.thumb} onError={e => {e.target.src = noThumb}} alt={image.title} />
                                                                    </Link>
                                                                </div>
                                                                <div className={styles.right}>
                                                                    <Link className={styles.content_title} target="_blank" rel="noreferrer" to={false} title="View">
                                                                        <strong><Markup content={image.title} /></strong>
                                                                    </Link>
                                                                    <div className={`${styles.btn_group} btn-group`}>
                                                                        <Link className="btn btn-danger" to={false} title="Unpublish" onClick={() => handleDelete(image.id)}>
                                                                            <i className="fa-regular fa-trash-can"></i>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </InfiniteScroll>
                                        : <EmptyContent />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                <Footer />
                </div>
            </div>
        </div>
    </>
  );
}

export default Videos;